import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { useActions, useValues } from 'kea';

import profilelogic from 'src/store/profile';

import AlertVehicle from './ReportTabs/AlertVehicle';
import GeofenceVehicle from './ReportTabs/GeofenceVehicle';
import Notification from './ReportTabs/Notification';
import Summary from './ReportTabs/Summary';
import Movement from './ReportTabs/Movement';
import Stationary from './ReportTabs/Stationary';
import Temperature from './ReportTabs/Temperature';
import History from './ReportTabs/History';
import BeaconMovement from './ReportTabs/BeaconMovement';
import Key from './ReportTabs/key';
import ErentReport from './ReportTabs/ErentReport';
import checkRole from 'src/utils/checkRole';

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.any.isRequired,
	value: PropTypes.any.isRequired,
};

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
		backgroundColor: theme.palette.background.paper,
	},
}));

export default function SimpleTabs() {
	const classes = useStyles();
	const [value, setValue] = React.useState(0);
	const { profile } = useValues(profilelogic);

	let tab_index = 0;
	let panel_index = 0;
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	return (
		<div className={classes.root}>
			<AppBar position="static" color="default" style={{ backgroundColor: '#ffffff' }}>
				<Tabs
					value={value}
					onChange={handleChange}
					indicatorColor="primary"
					textColor="primary"
					variant="scrollable"
					scrollButtons="auto"
					aria-label="simple tabs example"
				>
					<Tab label="Vehicle Summary" {...a11yProps(tab_index++)} />
					<Tab label="Movement" {...a11yProps(tab_index++)} />
					<Tab label="Stationary" {...a11yProps(tab_index++)} />
					{checkRole(profile, ['Admin']) && <Tab label="Alert" {...a11yProps(tab_index++)} />}
					{checkRole(profile, ['Admin']) && <Tab label="Geofence" {...a11yProps(tab_index++)} />}
					{checkRole(profile, ['Admin']) && <Tab label="Notifications" {...a11yProps(tab_index++)} />}
					{checkRole(profile, ['Admin']) && <Tab label="Temperature" {...a11yProps(tab_index++)} />}
					{checkRole(profile, ['Admin']) && <Tab label="Vehicle History" {...a11yProps(tab_index++)} />}
					{checkRole(profile, ['Admin']) && <Tab label="Beacon Movement" {...a11yProps(tab_index++)} />}
					{checkRole(profile, ['Admin']) && <Tab label="Key History" {...a11yProps(tab_index++)} />}
					{checkRole(profile, ['ErentReport'], false) && <Tab label="Erent Report" {...a11yProps(tab_index++)} />}
				</Tabs>
			</AppBar>
			<TabPanel value={value} index={panel_index++}>
				<Summary />
			</TabPanel>
			<TabPanel value={value} index={panel_index++}>
				<Movement />
			</TabPanel>
			<TabPanel value={value} index={panel_index++}>
				<Stationary />
			</TabPanel>
			<TabPanel value={value} index={panel_index++}>
				<AlertVehicle />
			</TabPanel>
			<TabPanel value={value} index={panel_index++}>
				<GeofenceVehicle />
			</TabPanel>
			<TabPanel value={value} index={panel_index++}>
				<Notification />
			</TabPanel>
			<TabPanel value={value} index={panel_index++}>
				<Temperature />
			</TabPanel>
			<TabPanel value={value} index={panel_index++}>
				<History />
			</TabPanel>
			<TabPanel value={value} index={panel_index++}>
				<BeaconMovement />
			</TabPanel>
			<TabPanel value={value} index={panel_index++}>
				<Key />
			</TabPanel>
			<TabPanel value={value} index={panel_index++}>
				<ErentReport />
			</TabPanel>
			{
				panel_index === 0 ?
					<TabPanel value={value} index={0}>
						<Typography>
							You need more permissions.
						</Typography>
					</TabPanel>
					:
					null
			}
		</div>
	);
}
